import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import _ from "lodash";
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import {confirmAlert} from "react-confirm-alert";
import RolesAdd from './../../elements/roles/widget/roles_add';

class Roles extends Component {
	render(){
		return(
			<RolesList {...this.props}/>
		);
	}

	componentWillMount(){
		const { roles } = this.props;
		this.props.rolesShow(roles.pages.current, roles.filters);
	}
}

export class RolesList extends Component{
	render() {
		const { roles } = this.props;
		let ru = _.find(roles.permissions, (o) => {return o==='Update'});
		let rd = _.find(roles.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{roles.isFetching ? <Loading/> :
					[<table className={`inm-table`} key="roles-table">
						<thead>
						<tr>
							<th>ID</th>
							<th>Perfil</th>
							<th>Tipo de perfil</th>
						</tr>
						</thead>
						<tbody>
						{_.map(_.orderBy(roles.list, ['id']), (row, k) => {
							return (
								<tr key={k}>
									<td style={{width: 10 + '%'}}>
										<div className="actions">
											{ru ? <NavLink to={`/perfiles/editar/${row.id}`}><i
												className="fa fa-edit"></i></NavLink> : ''}
											{rd && Boolean(row.editable) ? <button onClick={() => this._getConfirm(row.id, row.name)}><i
												className="fa fa-trash-o"></i></button> : ''}
										</div>
										{row.id}
									</td>
									<td><strong>{row.display}</strong></td>
									<td>{_.upperCase(row.agenciable_type ? row.agenciable_type : '')}</td>
								</tr>
							)
						})}
						</tbody>
					</table>,
				roles.pages.total > 20 &&
					<InmPagination key="roles-pages"
						current={roles.pages.current}
						total={roles.pages.total}
						nextPage={this._handlePageChange}
					/>
				]}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el perfil "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.deleteRole(id)
		})
	}

	_handlePageChange(value) {
		this.props.rolesShow(value);
	}
}

export default BaseLayout(Roles, {
	title: `Administrar Perfiles`,
	subnav: {
		icon: 'fa-user-secret',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <RolesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/roles/index.jsx